import { render, staticRenderFns } from "./CreateNotificationAction.vue?vue&type=template&id=69c93208"
import script from "./CreateNotificationAction.vue?vue&type=script&lang=js"
export * from "./CreateNotificationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports